import { useMutation } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';

const useInviteUserMutation = ({ onSuccess, onError } = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useMutation(
    async ({ fullName, displayName: displayNameInForm, email, role }) => {
      const agent = await firebase.getAgent();
      const displayName = displayNameInForm || email.split('@')[0];

      return await agent.post(`/o/${encodeURIComponent(orgId)}/users`).send({
        fullName,
        displayName,
        email,
        roles: [role.value],
      });
    },
    {
      onSuccess: (data, variables) => {
        onSuccess?.(data, variables);
      },
      onError: (error) => {
        onError?.(error);
      },
    },
  );
};

export default useInviteUserMutation;
